module.exports = __webpack_public_path__ + "static/media/javascript.9ccbfeae.jpg";